<template>
  <div class="patientList">
    <p class="w3-bar"> <label class="w3-bar-item only-text"> ნაპოვნია: {{filteredList.length}} პაციენტი </label>  <label class="w3-bar-item">სრული ინფორმაცია <input class="w3-check" v-model="options.displayFullData" type="checkbox"></label>  </p>
    <ul class="w3-ul w3-hoverable" >
      <li class="w3-bar" v-for="(patient, index) in filteredList" v-bind:key="index" v-on:dblclick="selectPatient('select', patient)">
        <div class="w3-twothird">
          <span class="w3-large">
            {{patient.name}} {{patient.surname}}
            <br>
            <span
              class="id_number"
              v-if="patient.id_number != null && patient.id_number != ''"
            >ID ნომერი:{{patient.id_number}}</span>
            <span>      დაწეს: {{patient.prison_name}}</span>
          </span>
          <div v-if="options.displayFullData">
            <span class="w3-margin-right" v-if="patient.date_of_birth">დაბ. თარიღი: {{patient.date_of_birth}}</span>
            <span class="w3-margin-right" v-if="patient.sex" >სქესი: {{patient.sex}}</span>
            <span class="w3-margin-right" v-if="patient.mobile_number">mobile: {{patient.mobile_number}}</span>
            <span v-if="patient.email">email: {{patient.email}}</span>
          </div>
          <!-- <p class="patientDataRest w3-tiny">{{patientList[index]}}</p> -->
        </div>
        <div class="buttons w3-third">
          <button
            v-if="isPrivilegedUser"
            class="w3-button w3-blue-grey w3-hover-red w3-right"
            v-on:click="selectPatient('remove', patient)"
          >remove</button>
          <button
            v-if="isPrivilegedUser"
            class="w3-button w3-blue-grey w3-hover-purple w3-right"
            v-on:click="selectPatient('edit', patient)"
          >edit</button>
          <button
            class="w3-button w3-blue-grey w3-hover-green w3-right"
            v-on:click="selectPatient('select', patient)"
          >select</button>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "patientList",
  props: ["filteredList"],
  data(){
    return {
      options: {
        displayFullData: false
      }
    }
  },
  computed: {
    ...mapGetters({isPrivilegedUser:"getIsprivilegedUser"}),
  },
  methods: {
    selectPatient(action, patient) {
      console.log(action + " patient on patient:")
      console.log(patient)
      this.$emit("patient-select", action, patient)
    }
  }
};
</script>

<style scoped>
.only-text{
  margin-top:6px;
}
</style>
